module.exports = {
      id: "question-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#question",
      toString: function () {
        return this.url;
      }
    }